import withTemplate from './spinner.vue.html';

export default withTemplate({
    props: {
        options: {
            type: Object,
            default: () => {},
        },
        modifiers: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        classModifiers() {
            return this.modifiers.map(m => `throbber__${m}`).join(' ');
        },
    },
});
